// Brand single source of truth (WSBF → WSTF rebrand, 2026-10).
export const BRAND_ACRONYM = "WSTF";
export const BRAND_NAME = "World Sports Trading Federation";
export const BRAND_DOMAIN = "ewstf.com";
export const BRAND_LOGO = "/assets/wstf-logo.png";
// Public contact address (one-line change).
export const CONTACT_EMAIL = "info@ewstf.com";
export const BRAND_TITLE = `${BRAND_ACRONYM} — ${BRAND_NAME}`;
